import { ConciliationCase } from "src/@types/conciliation-history";
import { ConciliationItemTypeEnum } from "@/constants/conciliation-history";

import { Tags } from "../enum/tags";
import { apiSlice } from "./http";

const CASE_TAG_ID_SEPARATOR: string = "-";

const caseTagOf = (
  itemType: ConciliationItemTypeEnum,
  itemId: number
): { type: Tags.CONCILIATION_HISTORY; id: string } => ({
  type: Tags.CONCILIATION_HISTORY,
  id: [itemType, itemId].join(CASE_TAG_ID_SEPARATOR),
});

export const conciliationHistoryInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDivergenceCase: builder.query<ConciliationCase, { divergenceId: number }>(
      {
        query: ({ divergenceId }) => ({
          url: `/conciliation-history/divergence/${divergenceId}`,
          method: "GET",
        }),
        providesTags: (_result, _error, { divergenceId }) => [
          caseTagOf(ConciliationItemTypeEnum.DIVERGENCE, divergenceId),
        ],
      },
    ),
    getNsuCase: builder.query<ConciliationCase, { nsuId: number }>({
      query: ({ nsuId }) => ({
        url: `/conciliation-history/nsu/${nsuId}`,
        method: "GET",
      }),
      providesTags: (_result, _error, { nsuId }) => [
        caseTagOf(ConciliationItemTypeEnum.NSU, nsuId),
      ],
    }),
  }),
});

export const { useGetDivergenceCaseQuery, useGetNsuCaseQuery } =
  conciliationHistoryInformations;
